import { Svg } from "@impero-com/ui";
import { cx } from "class-variance-authority";

import * as theme from "./theme.css";
import { ElementButtonSpec } from "./types";

/**
 * A button of the button panel. Can be dragged to the content panel.
 */
export interface ElementButtonProps<
    ElementButtonSpecId extends string,
> extends ElementButtonSpec<ElementButtonSpecId> {
    draggable: boolean;
    isDragging: boolean;
}
export function ElementButton<ElementButtonSpecId extends string>({
    id,
    icon,
    label,
    onClick,
    draggable,
    isDragging,
}: ElementButtonProps<ElementButtonSpecId>) {
    return (
        <div
            className={cx(
                theme.button,
                (() => {
                    if (draggable) {
                        return [theme.buttonHover, theme.draggable];
                    } else if (onClick) {
                        return [theme.buttonHover, theme.clickable];
                    } else {
                        return undefined;
                    }
                })()
            )}
            id={id}
            onClick={onClick}
        >
            <div
                className={
                    isDragging
                        ? theme.draggedButtonImageContainer
                        : theme.buttonImageContainer
                }
            >
                <Svg className={theme.buttonImage} src={icon.svg} />
            </div>
            <div className={theme.buttonLabel}>{label}</div>
        </div>
    );
}
